export type ResultadosRow = {
  label: string;
  valuePrev: string | number;
  valueCurr: string | number;
  isBold?: boolean;
  // Row metadata for V2 styling/behavior
  isResultadosSubtotal?: boolean;
  isResultadosDividerBottom?: boolean;
  isResultadosDividerTop?: boolean;
  isResultadosGroupHeader?: boolean;
};

// Orden de conceptos por categoría (Ventas, Costo de ventas, Producción agropecuaria, Costo de producción → Resultado bruto)
export const RESULTADOS_KEY_ORDER: Record<string, string[]> = {
  gross_result: ['sales', 'cost_of_sales', 'agricultural_production', 'production_cost'],
  operating_result: ['commercialization_expenses', 'administrative_expenses', 'other_income', 'other_expenses'],
  ordinary_result: ['financial_expenses', 'exchange_difference_and_holding_result'],
};

export type BuildResultadosRowsV1Args = {
  getMergedValues: (category: string) => Array<{ label: string; valuePrev: string | number; valueCurr: string | number }>;
  getTranslation: (category: string, label: string) => string;
  previousTotals: any;
  currentTotals: any;
  previousRiskData: any;
  currentRiskData: any;
  isResultadoBrutoFiltered?: boolean;
};

export type BuildResultadosRowsV2Args = {
  getTranslation: (category: string, label: string) => string;
  previousTotals: any;
  currentTotals: any;
  previousRiskData: any;
  currentRiskData: any;
  isOpen: boolean;
  isResultadoBrutoFiltered?: boolean;
};

